import React, { useState, useEffect, Suspense } from 'react';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import Alert from 'react-bootstrap/Alert';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPosts, updatePost, deletePost, createPost } from '../../redux/reducers/blogSlice'; // Certifique-se de importar corretamente
import Loader from '../../components/loading';
import PaginationComponent from '../../components/paginacao';
import Error from '../../components/error';
import api from '../../redux/actions/configApi';
const QuillEditor = React.lazy(() => import('../../../src/config/QuilEditor'));


const Blog = () => {

    const [selectedBlog, setSelectedBlog] = useState(null);
    const [deletePostId, setDeletePostId] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [showModaDelete, setShowModalDelete] = useState(false);
    const [showAlert, setAlert] = useState(false);
    const [showAlertError, setAlertError] = useState(false);
    const [categoriesAll, setCategoriesAll] = useState([]);
    const BASE_URL = process.env.REACT_APP_BASE_URL
    const [formState, setFormState] = useState({
        title: '',
        tag: '',
        key_words: '',
        category: '',
        order: '',
        image: '',
        imageCapa: '',
        autor: '',
        video: '',
        preview: '', // Previsualização da imagem/vídeo
        preview2: '', // Previsualização da imagem/vídeo
        resume: '', // Resumo do post
        content: '', // Conteúdo do post
        relatedPosts: [], // Posts relacionados
    });
    const initialFormState = {
        title: '',
        category: '',
        order: '',
        tag: '',
        key_words: '',
        resume: '',
        content: '',
        videoLink: '',
        relatedPosts: [],
        image: '',
        video: '',
        preview: '',
        preview2: '', // Previsualização da imagem/vídeo
        imageCapa: '',
        autor: '',
    };
    const [formStateEdit, setFormStateEdit] = useState(initialFormState);
    const dispatch = useDispatch();
    const { posts, loading, error, message } = useSelector((state) => state.blog);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(posts?.total / itemsPerPage);
    // Função para atualizar o estado do formulário
    const handleFormChange = (e) => {
        const { name, value, files } = e.target;
        const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2 MB
        let errorMessage = "";
        if (files?.[0] && files[0].size > MAX_FILE_SIZE) {
            errorMessage = "O arquivo deve ter no máximo 2 MB.";
            setFormState({
                ...formState,
                [`${name}Error`]: errorMessage, // Define o erro específico do campo
                [name === 'image' ? 'preview' : name === 'imageCapa' ? 'preview2' : '']: '', // Limpa a pré-visualização do campo que causou o erro
            });
            return;
        }
        if (name === 'image' && files?.[0]) {
            setFormState({
                ...formState,
                image: files[0],
                video: '', // Zera o vídeo se imagem for adicionada
                imageError: "", // Limpa o erro de validação
                videoLink: '', // Limpa o link do YouTube
                preview: URL.createObjectURL(files[0]), // Previsualização da imagem
            });
        } else if (name === 'imageCapa' && files?.[0]) {
            setFormState({
                ...formState,
                imageCapa: files[0],
                imageCapaError: "", // Limpa o erro de validação
                preview2: URL.createObjectURL(files[0]), // Previsualização da imagemCapa
            });
        } else if (name === 'video' && files?.[0]) {
            setFormState({
                ...formState,
                video: files[0],
                image: '', // Zera a imagem se vídeo for adicionado
                videoLink: '', // Limpa o link do YouTube
                preview: URL.createObjectURL(files[0]), // Previsualização do vídeo
            });
        } else if (name === 'videoLink' && value) {
            // Se o campo for videoLink, extrai o ID do YouTube
            const videoId = getYouTubeVideoId(value);
            setFormState({
                ...formState,
                videoLink: value,
                video: '', // Limpa o arquivo de vídeo
                image: '', // Limpa a imagem
                preview: videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : '', // Exibe a miniatura do vídeo
            });
        } else {
            setFormState({
                ...formState,
                [name]: value,
            });
        }
    };


    const handleFormChangeEdit = (e) => {
        const { name, value, files } = e.target;

        if (name === 'image' && files?.[0]) {
            setFormStateEdit({
                ...formStateEdit,
                image: files[0],
                video: '',
                videoLink: '',
                preview: URL.createObjectURL(files[0]),
            });
        } else if (name === 'imageCapa' && files?.[0]) {
            setFormStateEdit({
                ...formStateEdit,
                imageCapa: files[0],
                preview2: URL.createObjectURL(files[0]),
            });
        } else if (name === 'video' && files?.[0]) {
            setFormStateEdit({
                ...formStateEdit,
                video: files[0],
                image: '',
                videoLink: '',
                preview: URL.createObjectURL(files[0]),
            });
        } else if (name === 'videoLink') {
            const videoId = getYouTubeVideoId(value);
            setFormStateEdit({
                ...formStateEdit,
                videoLink: value || '',
                video: '',
                image: '',
                preview: videoId ,
                //preview2: '',
            });
        } else {
            setFormStateEdit({
                ...formStateEdit,
                [name]: value,
            });
        }
    };
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };
    // Função para visualizar detalhes do post
    const handleViewDetails = (post) => {
        console.log(post, 'post')
        setSelectedBlog(post);
        setShowModal(true);
    };
    const handleDeleteChange = (post) => {
        setDeletePostId(post.id);
        setShowModalDelete(true);
    };
    const confirmDelete = async () => {
        try {
            await dispatch(deletePost(deletePostId)).unwrap();
            setAlert(true)
        } catch (error) {
            console.error('Erro ao excluir o post:', error);
        } finally {
            setShowModalDelete(false); // Close the modal
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('title', formState.title);
        formData.append('category', formState.category);
        formData.append('order', formState.order);
        formData.append('tag', formState.tag);
        formData.append('key_words', formState.key_words);
        formData.append('resume', formState.resume);
        formData.append('content', formState.content);
        formData.append('videoLink', formStateEdit.videoLink || '');
        formData.append('autor', formState.autor); // Se videoLink for utilizado
        // Adiciona os posts relacionados, se houver
        formState.relatedPosts.forEach(postId => {
            formData.append('relatedPosts[]', postId); // Envia os posts relacionados
        });
        // Verifica se há imagem ou vídeo para enviar
        if (formState.image) formData.append('image', formState.image);
        if (formState.image) formData.append('image_capa', formState.imageCapa);
        if (formState.video) formData.append('video', formState.video);
        await dispatch(createPost(formData));
        // Ou enviar via fetch/axios se necessário
        setAlert(true)
        setShowModalAdd(false); // Fecha o modal, se aplicável
    };
    const handleSubmitEdit = async (e) => {
        e.preventDefault();
        const id = formStateEdit.id
        const formData = new FormData();
        formData.append('title', formStateEdit.title);
        formData.append('category', formStateEdit.category);
        formData.append('autor', formStateEdit.autor);
        formData.append('image_capa', formStateEdit.imageCapa);
        formData.append('order', formStateEdit.order);
        formData.append('tag', formStateEdit.tag);
        formData.append('key_words', formStateEdit.key_words);
        formData.append('resume', formStateEdit.resume);
        formData.append('content', formStateEdit.content);
        formData.append('videoLink', formStateEdit.videoLink || '');
        // Adiciona os posts relacionados, se houver
        formStateEdit.relatedPosts.forEach(postId => {
            formData.append('relatedPosts[]', postId); // Envia os posts relacionados
        });
        // Verifica se há imagem ou vídeo para enviar
        if (formStateEdit.image) formData.append('image', formStateEdit.image);
        if (formStateEdit.video) formData.append('video', formStateEdit.video);
        await dispatch(updatePost({ id, formData }));
        setAlert(true)
        setShowModalEdit(false); // Fecha o modal, se aplicável*/
    };
    /* const handleRelatedPostsChange = (e, postId) => {
         if (e.target.checked) {
             // Adiciona o post selecionado
             setFormState((prevState) => ({
                 ...prevState,
                 relatedPosts: [...prevState.relatedPosts, postId],
             }));
         } else {
             // Remove o post desmarcado
             setFormState((prevState) => ({
                 ...prevState,
                 relatedPosts: prevState.relatedPosts.filter((id) => id !== postId),
             }));
         }
     };*/
    /* const handleRelatedPostsChangeEdit = (e, postId) => {
         if (e.target.checked) {
             // Adiciona o post selecionado
             setFormStateEdit((prevState) => ({
                 ...prevState,
                 relatedPosts: [...prevState.relatedPosts, postId],
             }));
         } else {
             // Remove o post desmarcado
             setFormStateEdit((prevState) => ({
                 ...prevState,
                 relatedPosts: prevState.relatedPosts.filter((id) => id !== postId),
             }));
         }
     };*/
    const getYouTubeVideoId = (url) => {
        const regExp = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S+\/?)(?:[^\w\-\/\?=]+(\w+)\S*)|youtu\.be\/(\w+))/;
        const match = url.match(regExp);
        return match && (match[1] || match[2]);
    };
    const handleEdit = (post) => {
        // console.log(post, 'post')
        setFormStateEdit({
            id: post.id,
            title: post.title,
            category: post?.category_id,
            order: post.order,
            autor: post?.autor,
            tag: post.tags,
            key_words: post.key_words,
            resume: post.resume,
            content: post.content,
            videoLink: post.video,
            relatedPosts: post.related_posts?.map((related) => related.id), // Se o post tiver relacionamentos
            image: post.image, // Se houver imagem, preenche o estado
            video: post.video, // Se houver vídeo, preenche o estado
            preview: post.image,
            preview2: post.image_capa


        });
        setShowModalEdit(true); // Abre o modal
    };
    useEffect(() => {
        dispatch(fetchPosts(currentPage));
    }, [dispatch, currentPage]);
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await api.get('catall'); // Atualize a URL conforme necessário
                console.log(response.data, 'response.data')
                setCategoriesAll(response.data);
            } catch (err) {
                //setError('Erro ao carregar categorias.');
            } finally {
                //setLoading(false);
            }
        };
        fetchCategories();
    }, []); // Executa apenas uma vez ao carregar o componente

    useEffect(() => {
        setAlertError(true)
    }, [error]);
    const handleCloseError = () => {
        setAlertError(false)
    };

    const handleEditorChange = (newValue) => {
        setFormStateEdit((prevState) => ({ ...prevState, content: newValue }));
    };

    const handleADDChange = (newValue) => {
        setFormState((prevState) => ({ ...prevState, content: newValue }));
    };

    return (
        <Container>
            {message && (
                <Alert className="text-center" variant="success" show={showAlert}>
                    {message}
                    <Button className="m-3" variant="close" onClick={() => setAlert(false)} />
                </Alert>
            )}
            {showAlertError && <Error errors={error} onClose={handleCloseError} />}
            <div className='d-flex justify-content-center'>
                <PaginationComponent
                    currentPage={currentPage}
                    lastPage={totalPages}
                    onPageChange={handlePageChange}
                />
            </div>
            <div className={`loading ${loading ? 'loading-active' : ''}`}>
                <div className="d-flex justify-content-end mb-3">
                    <Button variant="primary" className='botao-acao' onClick={() => setShowModalAdd(true)}>
                        Adicionar Post
                    </Button>
                </div>
                <Loader loading={loading} />
                <Table bordered hover responsive className='text-center tabela-painel mt-4' style={{ fontSize: '0.7em' }}>
                    <thead>
                        <tr className='cabecalho-tabela'>
                            <th>Ordem</th>
                            <th>Título</th>
                            <th>Categoria</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {posts?.data?.map((post) => (
                            <tr key={post.id} className='celula-tabela'>
                                <td>{post.order}</td>
                                <td style={{ width: '400px' }}>{post.title}</td>
                                <td>{post?.category?.name}</td>
                                <td>
                                    <div class="table-actions">
                                        <Button
                                            variant="info"
                                            size="sm"
                                            className="me-2 botao-acao"
                                            onClick={() => handleViewDetails(post)}
                                        >
                                            Visualizar
                                        </Button>
                                        <Button
                                            variant="warning"
                                            size="sm"
                                            className="me-2 botao-acao"
                                            onClick={() => handleEdit(post)}
                                        >
                                            Editar
                                        </Button>
                                        <Button
                                            variant="danger"
                                            size="sm"
                                            className="me-2 botao-acao"
                                            onClick={() => handleDeleteChange(post)}
                                        >
                                            Excluir
                                        </Button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
            <Modal className="modal-custom" show={showModal} onHide={() => setShowModal(false)} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title className='w-100 text-center titulo-modal'>Detalhes do Post</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <p><strong>Resumo:</strong> {selectedBlog?.resume}</p>
                        <p><strong>Tags:</strong> {selectedBlog?.tags}</p>
                        <p><strong>Palavras Chaves:</strong> {selectedBlog?.key_words}</p>
                        <p><strong>Post</strong> {<div style={{ borderLeft: '5px solid rgb(243, 165, 44)', borderRadius: '10px', padding: '20px', marginTop: '20px', width: '100%' }} dangerouslySetInnerHTML={{ __html: selectedBlog?.content }} />}</p>
                        {/* <h5>Posts Relacionados:</h5>
                        <ul>
                            {posts?.data?.map((post) => (
                                <li key={post.id}>
                                    {post.id} - {post.title} - {post?.category?.name}
                                </li>
                            ))}
                        </ul>*/}
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={showModaDelete} onHide={() => setShowModalDelete(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Excluir Post</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Tem certeza de que deseja excluir este post?</p>
                    <div className="d-flex justify-content-end">
                        <Button variant="danger" onClick={confirmDelete} className="me-2">
                            Excluir
                        </Button>
                        <Button variant="secondary" onClick={() => setShowModalDelete(false)}>
                            Cancelar
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
            {/*cadastro do post*/}
            <Modal show={showModalAdd} onHide={() => setShowModalAdd(false)} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title className='w-100 text-center titulo-modal'>Adicionar Post</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Form.Group as={Col} md="10">
                                <Form.Label>Título:</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="title"
                                    value={formState.title}
                                    onChange={handleFormChange}
                                    required
                                />
                            </Form.Group>
                            <Form.Group as={Col} md="2">
                                <Form.Label>Ordem</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="order"
                                    value={formState.order}
                                    onChange={handleFormChange}
                                    required
                                />
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Col} md="6">
                                <Form.Label>Categoria</Form.Label>
                                <Form.Select
                                    name="category"
                                    value={formState.category}
                                    onChange={handleFormChange}
                                    className='form-control'

                                >
                                    <option value="">Selecione uma categoria</option>
                                    {categoriesAll?.map((cat) => (
                                        <option key={cat.id} value={cat.id}>
                                            {cat.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                            <Form.Group as={Col} md="6">
                                <Form.Label>Autor</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="autor"
                                    value={formState.autor}
                                    onChange={handleFormChange}
                                    required
                                />
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Col} md="4">
                                <Form.Label>Imagem Capa</Form.Label>
                                <Form.Control type="file" name="imageCapa" onChange={handleFormChange} />
                                {formState.imageCapaError && (
                                    <small style={{ color: "red" }}>{formState.imageCapaError}</small>
                                )}
                            </Form.Group>
                            <Form.Group as={Col} md="4">
                                <Form.Label>Imagem</Form.Label>
                                <Form.Control type="file" name="image" onChange={handleFormChange} />
                                {formState.imageError && (
                                    <small style={{ color: "red" }}>{formState.imageError}</small>
                                )}
                            </Form.Group>
                            <Form.Group as={Col} md="4">
                                <Form.Label>Link do YouTube</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="videoLink"
                                    value={formState.videoLink}
                                    onChange={handleFormChange}
                                    placeholder="Cole o link do vídeo do YouTube"
                                />

                            </Form.Group>
                            <Row>
                                <Col md="4">
                                    {formState.preview2 && (
                                        <div className="mt-3">
                                            {formState.imageCapa && <img src={formState.preview2} alt="Pré-visualização" style={{ width: '50%' }} />}
                                        </div>
                                    )}
                                </Col>
                                <Col md="4">
                                    {formState.preview && (
                                        <div className="mt-3">
                                            {formState.image && <img src={formState.preview} alt="Pré-visualização" style={{ width: '50%' }} />}
                                        </div>
                                    )}
                                </Col>
                                <Col md="4">
                                    {formState.videoLink && (
                                        <div className="mt-3">
                                            <iframe
                                                width="100%"
                                                height="315"
                                                src={`https://www.youtube.com/embed/${getYouTubeVideoId(formState.videoLink)}`}
                                                title="Vídeo do YouTube"
                                                frameBorder="0"
                                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen
                                            ></iframe>
                                        </div>
                                    )}
                                </Col>
                            </Row>
                        </Row>
                        <Row>
                            <Form.Group as={Col} md="12" className="mt-3">
                                <Form.Label>Resumo:</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    id="resume"
                                    name="resume"
                                    placeholder="Resumo do post"
                                    value={formState.resume}
                                    onChange={handleFormChange}
                                    rows={3}
                                    required
                                />
                            </Form.Group>
                            <Form.Group as={Col} md="12" className="mt-3">
                                <Form.Label>Conteúdo:</Form.Label>
                                <Suspense fallback={<div>Carregando editor...</div>}>
                                    <QuillEditor
                                        value={formState.content || ""}
                                        onChange={handleADDChange}
                                        uploadUrl={`${process.env.REACT_APP_API_URL}/upload-image`} // Correção aqui
                                        allowImages={false}
                                    />
                                </Suspense>
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Col} md="6">
                                <Form.Label>Tag:</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="tag"
                                    placeholder="Para múltiplas tags separe por ;"
                                    value={formState.tag}
                                    onChange={handleFormChange}
                                    required
                                />
                            </Form.Group>
                            <Form.Group as={Col} md="6">
                                <Form.Label>Palavras Chave:</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="key_words"
                                    value={formState.key_words}
                                    onChange={handleFormChange}
                                    placeholder="Para palavras separe por ;"
                                    required
                                />
                            </Form.Group>
                        </Row>
                        {/*<Row>
                            <Form.Group as={Col} md="12" className="mt-3">
                                <Form.Label>Posts Relacionados</Form.Label>
                                <div className="form-check-group" style={{ marginLeft: '15px' }}>
                                    {posts?.data?.map((post) => (
                                        <div key={post.id} className="form-check">
                                            <input
                                                type="checkbox"
                                                id={`relatedPost-${post.id}`}
                                                value={post.id}
                                                className="form-check-input"
                                                onChange={(e) => handleRelatedPostsChange(e, post.id)}
                                            />
                                            <label htmlFor={`relatedPost-${post.id}`} className="form-check-label">
                                                {post.title}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </Form.Group>
                        </Row>*/}
                        <Button type="submit" disabled={loading} className="mt-4">
                            {loading ? 'Salvando...' : 'Salvar'}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
            {/*Edicao*/}
            <Modal show={showModalEdit} onHide={() => setShowModalEdit(false)} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title className='w-100 text-center titulo-modal'>Editar Post</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmitEdit}>
                        <Row>
                            <Form.Group as={Col} md="10">
                                <Form.Label>Título:</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="title"
                                    value={formStateEdit.title}
                                    onChange={handleFormChangeEdit}
                                    required
                                />
                            </Form.Group>
                            <Form.Group as={Col} md="2">
                                <Form.Label>Ordem</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="order"
                                    value={formStateEdit.order}
                                    onChange={handleFormChangeEdit}
                                    required
                                />
                            </Form.Group>

                        </Row>
                        <Row>
                            <Form.Group as={Col} md="6">
                                <Form.Label>Categoria</Form.Label>
                                <Form.Select
                                    name="category"
                                    value={formStateEdit.category}
                                    onChange={handleFormChangeEdit}
                                >
                                    <option value="">Selecione uma categoria</option>
                                    {categoriesAll?.map((cat) => (
                                        <option key={cat.id} value={cat.id}>
                                            {cat.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                            <Form.Group as={Col} md="6">
                                <Form.Label>Autor</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="autor"
                                    value={formStateEdit.autor}
                                    onChange={handleFormChangeEdit}
                                    required
                                />
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Col} md="4">
                                <Form.Label>Imagem</Form.Label>
                                <Form.Control
                                    type="file"
                                    name="image"
                                    onChange={handleFormChangeEdit}
                                />
                            </Form.Group>
                            <Form.Group as={Col} md="4">
                                <Form.Label>Imagem Capa</Form.Label>
                                <Form.Control type="file" name="imageCapa" onChange={handleFormChangeEdit} />
                            </Form.Group>
                            {/* Exibindo a imagem selecionada */}
                            <Form.Group as={Col} md="4">
                                <Form.Label>Link do YouTube</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="videoLink"
                                    value={typeof formStateEdit.videoLink === 'string' ? formStateEdit.videoLink : ''}
                                    onChange={handleFormChangeEdit}
                                    placeholder="Cole o link do vídeo do YouTube"
                                />
                            </Form.Group>
                            <Row>
                                <Col md="4">
                                    {formStateEdit.preview &&
                                        !formStateEdit.preview.includes('/vi/null') &&
                                        !formStateEdit.preview.includes('/vi/undefined') && (
                                            <div className="mt-3">
                                                <img
                                                    src={
                                                        typeof formStateEdit.preview === 'string' &&
                                                            !formStateEdit.preview.startsWith('blob:')
                                                            ? `${BASE_URL}storage/${formStateEdit.preview}` // Caminho armazenado no backend
                                                            : formStateEdit.preview // URL gerada para pré-visualização
                                                    }
                                                    alt="Pré-visualização"
                                                    style={{ width: '60%', height: "auto" }}
                                                />
                                            </div>
                                        )}
                                </Col>
                                <Col md="4" >
                                    {formStateEdit.preview2 && (
                                        <div className="mt-3">
                                            <img
                                                src={
                                                    typeof formStateEdit.preview2 === 'string' && !formStateEdit.preview2.startsWith('blob:')
                                                        ? `${BASE_URL}storage/${formStateEdit.preview2}` // Caminho armazenado no backend
                                                        : formStateEdit.preview2 // URL gerada para pré-visualização
                                                }
                                                alt="Pré-visualização"
                                                style={{ width: '60%', height: 'auto' }}
                                            />
                                        </div>
                                    )}
                                </Col>
                                <Col md="4" >
                                    {formStateEdit?.video && (
                                        <div className="mt-3">
                                            <iframe
                                                width="100%"
                                                height="315"
                                                src={`https://www.youtube.com/embed/${getYouTubeVideoId(formStateEdit?.video)}`}
                                                title="Vídeo do YouTube"
                                                frameBorder="0"
                                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen
                                            ></iframe>
                                        </div>
                                    )}
                                </Col>
                            </Row>
                        </Row>
                        <Row>
                            <Form.Group as={Col} md="12" className="mt-3">
                                <Form.Label>Resumo:</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    id="resume"
                                    name="resume"
                                    placeholder="Resumo do post"
                                    value={formStateEdit.resume}
                                    onChange={handleFormChangeEdit}
                                    rows={3}
                                    required
                                />
                            </Form.Group>
                            <Form.Group as={Col} md="12" className="mt-3">
                                <Form.Label>Conteúdo:</Form.Label>
                                <Suspense fallback={<div>Carregando editor...</div>}>
                                    <QuillEditor
                                        value={formStateEdit.content || ""}
                                        onChange={handleEditorChange}
                                        uploadUrl={`${process.env.REACT_APP_API_URL}/upload-image`} // Correção aqui
                                        allowImages={false}
                                    />
                                </Suspense>
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Col} md="6">
                                <Form.Label>Tag:</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="tag"
                                    placeholder="Para múltiplas tags separe por ;"
                                    value={formStateEdit.tag}
                                    onChange={handleFormChangeEdit}
                                    required
                                />
                            </Form.Group>
                            <Form.Group as={Col} md="6">
                                <Form.Label>Palavras Chave:</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="key_words"
                                    value={formStateEdit.key_words}
                                    onChange={handleFormChangeEdit}
                                    placeholder="Para palavras separe por ;"
                                    required
                                />
                            </Form.Group>
                        </Row>
                        {/*<Row>
                            <Form.Group as={Col} md="12" className="mt-3">
                                <Form.Label>Posts Relacionados</Form.Label>
                                <div className="form-check-group" style={{ marginLeft: '15px' }}>
                                    {posts?.data?.map((post) => (
                                        <div key={post.id} className="form-check">
                                            <input
                                                type="checkbox"
                                                id={`relatedPost-${post.id}`}
                                                value={post.id}
                                                className="form-check-input"
                                                checked={formStateEdit?.relatedPosts?.includes(post.id)} // Marcar posts já selecionados
                                                onChange={(e) => handleRelatedPostsChangeEdit(e, post.id)}
                                            />
                                            <label htmlFor={`relatedPost-${post.id}`} className="form-check-label">
                                                {post.title}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </Form.Group>
                        </Row>*/}
                        <Button type="submit" disabled={loading} className="mt-4">
                            {loading ? 'Salvando...' : 'Salvar'}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </Container >
    );
};

export default Blog;
